import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'banner-expired-access',
  templateUrl: './expired-access-banner.component.html',
  styleUrls: ['./expired-access-banner.component.scss']
})
export class ExpiredAccessBannerComponent implements OnInit {

  @Input()
  organizationName: string = 'Organization Name';

  constructor() { }

  ngOnInit() {
  }

}
